import React, { Component } from "react";
import { Link, Route, withRouter, Switch, Redirect } from "react-router-dom";
import Footer from "../../Footer/Footer";
import ChooseArbitratorForCaseInformation from "../ChooseArbitratorForCaseInformation";

import searchBtnEng from "../../../images/searchBtnEng.png";
import awardBtnEng from "../../../images/awardBtnEng.png";
import settlementBtnEng from "../../../images/settlementBtnEng.png";
import responseBtnEng from "../../../images/responseBtnEng.png";
import uploadDocBtnEng from "../../../images/uploadDocBtnEng.png";
import arbitrationNoticeBtnEng from "../../../images/arbitrationNoticeBtnEng.png";
import caseInfoBtnEng from "../../../images/caseInfoBtnEng.png";
import appointArbitratorEng from "../../../images/appointArbitratorEng.png"; 
import searchBtn from "../../../images/searchBtn.png";
import awardBtn from "../../../images/awardBtn.png";
import settlementBtn from "../../../images/settlementBtn.png";
import responseBtn from "../../../images/responseBtn.png";
import uploadDocBtn from "../../../images/uploadDocBtn.png";
import arbitrationNoticeBtn from "../../../images/arbitrationNoticeBtn.png";
import caseInfoBtn from "../../../images/caseInfoBtn.png";
import appointArbitrator from "../../../images/appointArbitrator.png"; 

import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import withSizes from "react-sizes";

import CaseInformation from "../CaseInformation";
import EnquirySubmission from "../EnquirySubmission";
import ArbitratorNotice from "../ArbitratorNotice";
import Award from "../Award";
import DocsList from "../DocsList";
import Settlement from "../Settlement";
import Response from "../Response";
import PrimaryAppBar from "../../../components/PrimaryAppBar";

const styles = (theme) => ({
    isMobileFormControl: {
      marginLeft: "auto",
      marginRight: "auto",
    },
    active_tabStyle: {
      color: "white",
      backgroundColor: "#B71C1C",
      outline: "0",
    },
    container: {
      width: "100vw",
    },
    [theme.breakpoints.down("xs")]: {
      tabLabel: {
        fontSize: 12,
      },
    },
    [theme.breakpoints.up("sm")]: {
      tabLabel: {
        fontSize: 12,
      },
    },
    [theme.breakpoints.up("md")]: {
      tabLabel: {
        fontSize: 12,
      },
    },
    btn:{
        marginBottom:'10px'
    },
    btnimg:{
        width:'100%'
    },
    root: {
        width: "100vw",
        '@media (max-width: 480px)': {
            width: '100vw'
        }
    }
  });
class MainPanelDesktop extends Component {
    render(){
        const {
            typeOfAccount,
            windowWidth,
            isMobile,
            classes,
            handleChange,
            value,
            lang,
            caseData,
            isDesktop,
            claimant_docs,
            respondent_docs,
            admin_docs,
            userType
         } = this.props;
        if (typeOfAccount == 'arbitrator'){          
            return(
                <div className={classes.root}>
                    <PrimaryAppBar />
                    {value == undefined && <Grid container spacing={0} 
                    style={{
                        paddingLeft: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                        paddingRight: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                    }}>
                    
                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 0)}}>
                        <img className={classes.btnimg} src={lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 1)}}>
                        <img className={classes.btnimg}  src={lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 2)}}>
                        <img className={classes.btnimg}  src={lang == 'cn'?responseBtn : responseBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 3)}}>
                        <img className={classes.btnimg}  src={lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 7)}}>
                        <img className={classes.btnimg}  src={lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 5)}}>
                        <img className={classes.btnimg}  src={lang == 'cn'?searchBtn: searchBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 6)}}>
                        <img className={classes.btnimg}  src={lang == 'cn'?awardBtn: awardBtnEng}></img>
                        </Button>
                    </Grid>

                   
                    
                    </Grid>}

                        {value === 0 && <CaseInformation handleChange={handleChange} caseData={caseData}/>}
                        {value === 1 && <ArbitratorNotice handleChange={handleChange}/>}
                        {value === 2 && <Response handleChange={handleChange}/>}
                        {value === 3 && <DocsList handleChange={handleChange} caseData={caseData} docs={{ claimant_docs: claimant_docs, respondent_docs: respondent_docs, admin_docs: admin_docs}} showUploadDocs={userType ==='All'} />}
                        {value === 4 && <Settlement handleChange={handleChange}/>}
                        {value === 5 && <EnquirySubmission handleChange={handleChange}/>}
                        {value === 6 && <Award handleChange={handleChange}/>}
                        {value === 7 && <ChooseArbitratorForCaseInformation handleChange={handleChange} caseData={caseData}/>}

                    {isDesktop && <Footer />}
                </div>
            );
        }
        else if (typeOfAccount == 'admin'){
            return(
                <div className={classes.root}>
                    <PrimaryAppBar />
                    {value == undefined && <Grid container spacing={0} 
                    style={{
                        paddingLeft: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                        paddingRight: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                    }}>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 0)}}>
                        <img className={classes.btnimg} src={lang == 'cn'?caseInfoBtn : caseInfoBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 1)}}>
                        <img className={classes.btnimg}  src={lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 2)}}>
                        <img className={classes.btnimg}  src={lang == 'cn'?responseBtn : responseBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 3)}}>
                        <img className={classes.btnimg} src={lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 7)}}>
                        <img className={classes.btnimg} src={lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 4)}}>
                        <img className={classes.btnimg} src={lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 5)}}>
                        <img className={classes.btnimg} src={lang == 'cn'?searchBtn: searchBtnEng}></img>
                        </Button>
                    </Grid>

                    <Grid item xs={3}>
                        <Button className={classes.btn} onClick={(e)=>{handleChange(e, 6)}}>
                        <img className={classes.btnimg} src={lang == 'cn'?awardBtn: awardBtnEng}></img>
                        </Button>
                    </Grid>

                    
                    
                    </Grid>}

                        {value === 0 && <CaseInformation handleChange={handleChange} caseData={caseData}/>}
                        {value === 1 && <ArbitratorNotice handleChange={handleChange}/>}
                        {value === 2 && <Response handleChange={handleChange}/>}
                        {value === 3 && <DocsList handleChange={handleChange} caseData={caseData} docs={{ claimant_docs: claimant_docs, respondent_docs: respondent_docs, admin_docs: admin_docs}} showUploadDocs={userType ==='All'} />}
                        {value === 4 && <Settlement handleChange={handleChange}/>}
                        {value === 5 && <EnquirySubmission handleChange={handleChange}/>}
                        {value === 6 && <Award handleChange={handleChange}/>}
                        {value === 7 && <ChooseArbitratorForCaseInformation handleChange={handleChange} caseData={caseData}/>}

                    {isDesktop && <Footer />} 
                </div>
            );
        }
        else if (typeOfAccount == 'user' || typeOfAccount == 'claimant' || typeOfAccount == 'respondent'){
            if (caseData !== undefined && caseData !== null){
                if (caseData.teleconferencing !== undefined){
                    if (caseData.teleconferencing == true){

                        return (
                        <div className={classes.root}>
                            <PrimaryAppBar />
                            {value == undefined && <Grid container spacing={0} 
                            style={{
                                paddingLeft: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                                paddingRight: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                            }}>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 0)}}>
                                <img className={classes.btnimg} src={lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 1)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 2)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?responseBtn : responseBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 3)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 7)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 4)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 5)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?searchBtn: searchBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 6)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?awardBtn: awardBtnEng}></img>
                                </Button>
                            </Grid>

                           
                            
                            </Grid>}

                                {value === 0 && <CaseInformation handleChange={handleChange} caseData={caseData}/>}
                                {value === 1 && <ArbitratorNotice handleChange={handleChange} />}
                                {value === 2 && <Response handleChange={handleChange} caseData={caseData}/>}
                                {/* {value === 3 && <DocsList handleChange={handleChange} caseData={caseData} docs={{ claimant_docs: claimant_docs, respondent_docs: respondent_docs}} showUploadDocs={userType ==='All'} />} */}
                                {value === 4 && <Settlement handleChange={handleChange} caseData={caseData}/>}
                                {value === 5 && <EnquirySubmission handleChange={handleChange} caseData={caseData}/>}
                                {value === 6 && <Award handleChange={handleChange} caseData={caseData}/>}
                                {value === 7 && <ChooseArbitratorForCaseInformation handleChange={handleChange} caseData={caseData}/>}

                            {isDesktop && <Footer />}
                        </div>
                        );
                }
                else{
                    return(
                        <div className={classes.root}>
                            <PrimaryAppBar />
                            {value == undefined && 
                            <Grid container spacing={0} 
                            style={{
                                paddingLeft: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                                paddingRight: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                            }}>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 0)}}>
                                <img className={classes.btnimg} src={lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 1)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 2)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?responseBtn : responseBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 3)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e,7)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 4)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 5)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?searchBtn: searchBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 6)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?awardBtn: awardBtnEng}></img>
                                </Button>
                            </Grid>

                            </Grid>}
                                {value === 0 && <CaseInformation handleChange={handleChange} caseData={caseData}/>}
                                {value === 1 && <ArbitratorNotice handleChange={handleChange}/>}
                                {value === 2 && <Response handleChange={handleChange}/>}
                                {value === 3 && <DocsList handleChange={handleChange} caseData={caseData} docs={{ claimant_docs: claimant_docs, respondent_docs: respondent_docs, admin_docs: admin_docs}} showUploadDocs={userType ==='All'} />}
                                {value === 4 && <Settlement handleChange={handleChange}/>}
                                {value === 5 && <EnquirySubmission handleChange={handleChange} caseData={caseData}/>}
                                {value === 6 && <Award handleChange={handleChange} caseData={caseData}/>}
                                {value === 7 && <ChooseArbitratorForCaseInformation handleChange={handleChange} caseData={caseData}/>}
                            {isDesktop && <Footer />}
                        </div>
                    );
                }
            }
            else{
                return(
                    <div className={classes.root}>
                        <PrimaryAppBar />
                        {value == undefined && <Grid container spacing={0} 
                            style={{
                                paddingLeft: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                                paddingRight: (!isMobile) ? (windowWidth > 900 ? '300px':'') : '',
                            }}>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 0)}}>
                                <img className={classes.btnimg} src={lang == 'cn'?caseInfoBtn:caseInfoBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 1)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?arbitrationNoticeBtn : arbitrationNoticeBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 2)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?responseBtn : responseBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 3)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?uploadDocBtn: uploadDocBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 7)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?appointArbitrator: appointArbitratorEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 4)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?settlementBtn: settlementBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 5)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?searchBtn: searchBtnEng}></img>
                                </Button>
                            </Grid>

                            <Grid item xs={3}>
                                <Button className={classes.btn} onClick={(e)=>{handleChange(e, 6)}}>
                                <img className={classes.btnimg}  src={lang == 'cn'?awardBtn: awardBtnEng}></img>
                                </Button>
                            </Grid>

                          
                            
                            </Grid>}
                                {value === 0 && <CaseInformation handleChange={handleChange} caseData={caseData}/>}
                                {value === 1 && <ArbitratorNotice handleChange={handleChange} caseData={caseData}/>}
                                {value === 2 && <Response handleChange={handleChange} caseData={caseData}/>}
                                {value === 3 && <DocsList handleChange={handleChange} caseData={caseData} docs={{ claimant_docs: claimant_docs, respondent_docs: respondent_docs, admin_docs: admin_docs }} showUploadDocs={userType ==='All'} />}
                                {value === 4 && <Settlement handleChange={handleChange} caseData={caseData}/>}
                                {value === 5 && <EnquirySubmission handleChange={handleChange} caseData={caseData}/>}
                                {value === 6 && <Award handleChange={handleChange} caseData={caseData}/>}
                                {value === 7 && <ChooseArbitratorForCaseInformation handleChange={handleChange} caseData={caseData}/>}
                            {isDesktop && <Footer />}
                    </div>
                );
            }
        }
        else{
            return(
                <div className={classes.button}>
                    <CircularProgress size={25} thickness={2} className={classes.loading}/>
                </div>
            )

        }

        }
        
    }
}

export default (withStyles(styles)(withRouter(MainPanelDesktop)));




